import {ReactionSource} from '@/domain/models/Reaction';
import {User} from '@/domain/models/User';

export enum ProfileModal {
  EditProfile = 'editProfile',
  Prompts = 'prompts',
  Languages = 'languages',
  Ethnicities = 'ethnicities',
  Nationalities = 'nationalities',
  Interests = 'interests',
}

export enum FiltersModalView {
  main = 'main',
  languages = 'languages',
  ethnicities = 'ethnicities',
  nationalities = 'nationalities',
  interests = 'interests',
  goals = 'goals',
  locations = 'locations',
  countries = 'countries',
}

export type UserModal = {
  user: User;
  source: ReactionSource;
};

/**
 * web_land_e1 - test first AB test on the landing page /land_e1
 * web_cookie_banner_v2 - test non-blocking cookie banner
 * web_land_vs_onboard - test landing page vs onboarding
 * web_cookie_banner_v3 - rerun test non-blocking cookie banner
 * signup_email_vs_oauth - test sign up with oAuth buttons and without
 * cookie_banner_gender_vs_goal - test cookie banner on first or goal step
 * login_lite_onboarding_two_screens - test additional 2 steps
 */
export type SIGN_UP_AB_TESTS = 'login_lite_onboarding_two_screens';

/**
 * web_new_checkout_page - test renewed checkout page
 */
export type USER_AB_TESTS = 'web_new_checkout_page';
